export const WIDGET_PRE = "jeecg-"

